export enum CustomerDisplayScreen {
  LockedScreen = 'LockedScreen',

  IdleScreen = 'IdleScreen',

  SalesScreen = 'SalesScreen',

  ThankYou = 'ThankYou',

  TenderExchange = 'TenderExchange',
}
